'use strict';

document.addEventListener("DOMContentLoaded", function (event) {

    if (!Array.prototype['forEach']) {
        Array.prototype.forEach = function(callback, thisArg) {
            if (this == null) { throw new TypeError('Array.prototype.forEach called on null or undefined'); }
            var T, k, O = Object(this), len = O.length >>> 0;
            if (typeof callback !== "function") { throw new TypeError(callback + ' is not a function'); }
            if (arguments.length > 1) { T = thisArg; }
            k = 0; while (k < len) { var kValue; if (k in O) { kValue = O[k]; callback.call(T, kValue, k, O); } k++; }
        };
    }

    var vacancyFilterSection = document.querySelectorAll('[data-vacancy-filters]');
    var vacancyFilters = document.querySelectorAll('[data-vacancy-filters] select');
    var locationSelect = document.querySelector('[data-vacancy-filter="location"]');
    var divisionSelect = document.querySelector('[data-vacancy-filter="division"]');
    var regionSelect = document.querySelector('[data-vacancy-filter="region"]');
    var vacancyResults = document.querySelector('[data-vacancy-list-results]');
    
    function doFilters() {
        var locationVal = locationSelect ? locationSelect.options[locationSelect.selectedIndex].value : 'All';
        var divisionVal = divisionSelect ? divisionSelect.options[divisionSelect.selectedIndex].value : 'All';
        var regionVal = regionSelect ? regionSelect.options[regionSelect.selectedIndex].value : 'All';

        var filteredData = vacancyItems.filter(function (e) {
            return (locationVal === 'All' || !locationVal || e.location === locationVal) && (divisionVal === 'All' || !divisionVal || e.division === divisionVal) && (regionVal === 'All' || !regionVal || e.region === regionVal);
        });

        vacancyResults.innerHTML = '';

        filteredData.forEach(function (el) {
            var html = '';
            el.url !== undefined ? (html += '<a class="row vacancy-list-item" href="' + el.url + '"') : '<span class="vacancy-list-item"';
            el.location !== undefined && (html += ' data-location="' + el.location + '"');
            el.division !== undefined && (html += ' data-division="' + el.division + '"');
            el.region !== undefined && (html += ' data-region="' + el.region + '"');
            html += '>';
            html += '<div class="col-md-12 vacancy-list-header">' + (el.title !== undefined ? '<span aria-label="Position">' + el.title + '</span>' : '') + '</div>';
            html += '<div class="col-md-12 vacancy-list-details">' + (el.location ? '<span aria-label="Location">' + el.location + '</span>' : '');
            html += (el.division !== undefined && divisionSelect ? '<span aria-label="Division">' + el.division_translated + '</span>' : '');
            html += (el.date !== undefined ? '<span aria-label="Application deadline">' + el.date + '</span>' : '') + '</div>';
            html += (el.url !== undefined ? '</a>' : '</span>');
            vacancyResults.innerHTML += html;
        });

        if (vacancyResults.innerHTML === '') {
            vacancyResults.innerHTML += '<div class="vacancy-list-item">' + vacancyResults.dataset.noVacanciesFound + '</div>';
        }
    }

    if (vacancyFilterSection !== null && vacancyFilters.length > 0) {
        doFilters();

        vacancyFilters.forEach(function (select) {
            select.addEventListener('change', function () {
                doFilters(vacancyItems);
            }, false);
        });
    }
});